import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Box, TextField, Button, Typography } from '@mui/material';
import authProvider from '../provider/AuthProvider';
import { GoogleLogin } from '@react-oauth/google'; // Updated import

const AuthPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [tenantId, setTenantId] = useState<string | null>(null);  // Added state for tenantId
    const navigate = useNavigate();

    const handleLogin = async () => {
        setError(null);
        try {
            const user = await authProvider.login({ email, password });
            console.log('User logged in:', user);
            setTenantId(user.tenantId);  // Store tenantId in the state
            navigate('/dashboard'); // Redirect to dashboard on success
        } catch (err: any) {
            console.error('Login error:', err);
            setError(err.message || 'Login failed.');
        }
    };

    const handleGoogleLogin = async (response: any) => {
        setError(null);
        try {
            // Call the googleLogin method from authProvider
            const user = await authProvider.googleLogin(response);
            console.log('Google login successful:', user);
            setTenantId(user.tenantId);  // Store tenantId from Google login
            navigate('/dashboard'); // Redirect to dashboard on success
        } catch (err: any) {
            console.error('Google Login error:', err);
            setError(err.message || 'Google login failed.');
        }
    };

    const handleGoogleError = () => {
        console.error('Google login failed');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f4f4f4',
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#fff',
                    padding: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                    width: '100%',
                    maxWidth: 400,
                    textAlign: 'center',
                }}
            >
                <Typography variant="h5" sx={{ marginBottom: 3 }}>
                    Login
                </Typography>
                {error && (
                    <Typography sx={{ color: 'red', marginBottom: 2 }}>
                        {error}
                    </Typography>
                )}
                <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ marginBottom: 2 }}
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{ marginBottom: 3 }}
                />
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleLogin}
                    sx={{ marginBottom: 2 }}
                >
                    Login
                </Button>
                <GoogleLogin
                    onSuccess={handleGoogleLogin}
                    onError={handleGoogleError} // Updated error handler
                    useOneTap
                    size="large"
                    theme="outline"
                />
                <Typography
                    component={Link}
                    to="/signup"
                    sx={{
                        marginTop: 3,
                        display: 'block',
                        textDecoration: 'none',
                        color: 'blue',
                        '&:hover': { textDecoration: 'underline' },
                    }}
                >
                    Don't have an account? Sign Up
                </Typography>
                {tenantId && (  // Conditionally render tenantId
                    <Typography sx={{ marginTop: 2 }}>
                        Tenant ID: {tenantId}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default AuthPage;
